package com.arena_web.utils

import kotlinx.browser.document
import kotlinx.browser.window

/**
 * Consent-gated Google Analytics 4 loader.
 *
 * gtag.js is injected only after the user accepts the cookie banner, so
 * declined/undecided visitors never load Google scripts (GDPR-clean).
 * With a blank [MEASUREMENT_ID] the whole object is a no-op, so the site
 * works fine until a real GA4 property is created.
 */
object Analytics {
    // TODO: создать GA4-property (analytics.google.com → Admin → Data Streams
    //  → Web → arenaproplay.com) и вставить сюда его Measurement ID.
    private const val MEASUREMENT_ID = "" // e.g. "G-XXXXXXXXXX"

    // Mirrors COOKIE_CONSENT_KEY in CookieConsent.kt.
    private const val CONSENT_KEY = "cookie_consent"

    private var loaded = false

    /** Loads GA on app start if consent was already given on a past visit. */
    fun initIfConsented() {
        if (Storage.get(CONSENT_KEY) == "accepted") load()
    }

    /** Call when the user taps Accept on the cookie banner. */
    fun onConsentGranted() = load()

    private fun load() {
        if (loaded || MEASUREMENT_ID.isBlank()) return
        loaded = true

        val script = document.createElement("script")
        script.setAttribute("async", "")
        script.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=$MEASUREMENT_ID")
        document.head?.appendChild(script)

        js(
            """
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
            """
        )
        window.asDynamic().gtag("config", MEASUREMENT_ID)

        hookSpaNavigation()
    }

    // Kobweb is an SPA — GA's automatic page_view fires only on the initial
    // load, so re-emit it on every history push/pop (route change).
    private fun hookSpaNavigation() {
        js(
            """
            var pushState = history.pushState;
            history.pushState = function () {
                pushState.apply(history, arguments);
                window.gtag('event', 'page_view', { page_path: location.pathname, page_title: document.title });
            };
            window.addEventListener('popstate', function () {
                window.gtag('event', 'page_view', { page_path: location.pathname, page_title: document.title });
            });
            """
        )
    }
}
